import { Injectable, OnInit } from "@angular/core";
import { environment } from "../../environments/environment";
import { PopupConfigService } from "../popup-config/popup-config.service";
import { isNullOrUndefined } from "is-what";
import { CodigoAcaoEnum } from '../shared/Util'
import { SvgService } from "./svg.service";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class IconService implements OnInit{

    constructor(public popupConfigService: PopupConfigService, private svgService:SvgService, private sanitizer:DomSanitizer){}

    public corPadraoIcone = [
        {codigo:0,cor:'E9B448', nome:'emAberto'},
        {codigo:1,cor:'5B9DEF', nome:'noCliente'},
        {codigo:2,cor:'5B9DEF', nome:'entregaIniciada'},
        {codigo:3,cor:'E9B448', nome:'voltoDepois'},
        {codigo:4,cor:'BC4100', nome:'naoEntregue'},
        {codigo:5,cor:'009533', nome:'entregue'}
    ];

    public corEscolhidaIcone = [
        {codigo:0, cor:'E9B448', nome:'emAberto'},
        {codigo:1, cor:'5B9DEF', nome:'noCliente'},
        {codigo:2, cor:'5B9DEF', nome:'entregaIniciada'},
        {codigo:3, cor:'E9B448', nome:'voltoDepois'},
        {codigo:4, cor:'BC4100', nome:'naoEntregue'},
        {codigo:5, cor:'009533', nome:'entregue'}
    ];

    //AtualizaConfiguração dos ícones
    public configuracao = null;

    ngOnInit(){}

    public iconeCliente(index, codigoAcao, temOcorrencia, parcial, IdRoteiroPedidoSituacao?, statusEntrega?, regiaoRisco?,  naoSanitizado?, temColeta?, temImportacaoXML?   ){

      this.corEscolhidaIcone = [
        {codigo:0, cor:'C0C1C3', nome:'emAberto'},
        {codigo:1, cor:'0288D1', nome:'noCliente'},
        {codigo:2, cor:'0288D1', nome:'entregaIniciada'},
        {codigo:3, cor:'FF9D43', nome:'voltoDepois'},
        {codigo:4, cor:'E53935', nome:'naoEntregue'},
        {codigo:5, cor:'00A745', nome:'entregue'}
    ];

        let corIcone = null;
        let alerta = "nada";
        let alertaDuplo = false;
        let regiaoRiscoIcon

        if(regiaoRisco){
            if (regiaoRisco == 'ALAGAMENTO'){
             regiaoRiscoIcon ='alag'
            }else if(regiaoRisco == 'FURTO/ROUBO'){
             regiaoRiscoIcon = 'furto'
            }
        }else{
         regiaoRiscoIcon = 'false'
        }


        if(temOcorrencia && parcial){
            alerta = "nada";
            alertaDuplo = true;
        }else if(temOcorrencia){
            alerta = "alto";
        }else if(parcial){
            alerta = "medio";
        }
        let voltoDepois =  codigoAcao == 3;
        let entrega = codigoAcao == 2;

        //Set padrão caso não exista valor.
        if(!isNullOrUndefined(IdRoteiroPedidoSituacao) || (!isNullOrUndefined(statusEntrega))){
            if(statusEntrega > 0){
                voltoDepois = statusEntrega == 10;
                entrega = statusEntrega == 11;
            }else{
                voltoDepois = IdRoteiroPedidoSituacao == 4;
                entrega = IdRoteiroPedidoSituacao == 3;
            }
            let codAux = this.conversorCodigoAcao(IdRoteiroPedidoSituacao, statusEntrega);
            corIcone = this.corEscolhidaIcone.find(item => { return item.codigo == codAux});
        }else if(codigoAcao == null && isNullOrUndefined(IdRoteiroPedidoSituacao)){
            corIcone = this.corEscolhidaIcone.find(item => { return item.codigo == 0});
        }else{
            corIcone = this.corEscolhidaIcone.find(item => {
                return item.codigo == codigoAcao;
            });
        }

        corIcone = corIcone.cor;
        let options = {icone:"RotaClienteSelDashboard",alerta: alerta ,alertaDuplo: alertaDuplo,index: index ,cor: corIcone ,regiaoRisco: regiaoRiscoIcon ,REntrega: entrega,RVoltaDepois:false,RHorario:false, RFeriado:false, RPedido:false, Opacidade:1, RColeta: temColeta? temColeta : false, RImportacaoXML: temImportacaoXML? temImportacaoXML : false}

        let url =  this.svgService.geraSVG(options)
        let urlSanitizado = this.sanitizer.bypassSecurityTrustResourceUrl(url)
        if(naoSanitizado==true){
          return url
        }


        return urlSanitizado;
    }

    conversorCodigoAcao(IdRoteiroPedidoSituacao, statusEntrega?){
        let CodigoAcao = 0;
        if((statusEntrega != null || statusEntrega != undefined) && statusEntrega > 6){
            switch (statusEntrega) {
                case 7: CodigoAcao = 5; break;
                case 8: CodigoAcao = 0; break;
                case 9: CodigoAcao = 1; break;
                case 10: CodigoAcao = 3; break;
                case 11: CodigoAcao = 2; break;
                default: CodigoAcao = 0; break;
            }
        }else{
            switch (IdRoteiroPedidoSituacao) {
                case 1: CodigoAcao = 0; break;
                case 2: CodigoAcao = 1; break;
                case 3: CodigoAcao = 2; break;
                case 4: CodigoAcao = 3; break;
                case 5: CodigoAcao = 4; break;
                case 6: CodigoAcao = 5; break;
                case 7: CodigoAcao = 5; break;
                default: CodigoAcao = 0; break;
              }
        }

        return CodigoAcao;
    }

    async novaCor(cor, codigo){
        this.corEscolhidaIcone.filter(item => {
            //Popula objeto 'volto depois'
            if(codigo == 0 && item.codigo == 3){
                item.cor = cor;
            }
            //Popula objeto 'entregaIniciada'
            if(codigo == 1 && item.codigo == 2){
                item.cor = cor;
            }

            if(codigo == item.codigo){
                item.cor = cor;
            }
        });

        //Salvar novo objeto
        await this.alterarConfigIcones(JSON.stringify(this.corEscolhidaIcone));
    }

    async resetAll(){
        //TODO - salvar nas configurações a nova cor.
        this.corEscolhidaIcone = this.corPadraoIcone;
        await this.alterarConfigIcones(JSON.stringify(this.corEscolhidaIcone));
    }

    async reset(codigo){
        let cor = '';

        this.corEscolhidaIcone.filter(item => {
            let aux;
            //Popula objeto 'volto depois'
            if(codigo == 0 && item.codigo == 3){
                aux = this.corPadraoIcone.find(item => { return codigo == item.codigo});
                item.cor = aux.cor;
            }
            //Popula objeto 'entregaIniciada'
            if(codigo == 1 && item.codigo == 2){
                aux = this.corPadraoIcone.find(item => { return codigo == item.codigo});
                item.cor = aux.cor;
            }

            if(codigo == item.codigo){
                aux = this.corPadraoIcone.find(item => { return codigo == item.codigo});
                item.cor = aux.cor;
                cor = aux.cor;
            }
        });
        await this.alterarConfigIcones(JSON.stringify(this.corEscolhidaIcone));
        return '#'+cor;
    }

    retornarCor(codigo, padrao){
        let obj = null;
        if(padrao){
            obj = this.corPadraoIcone.find(item => {return codigo == item.codigo});
        }else{
            obj = this.corEscolhidaIcone.find(item => {return codigo == item.codigo});
        }
        return '#'+obj.cor;
    }

    corBorda(color: string) : string
    {
        color = color.replace('#', '');
	    let f = 0.5;
		let pAux = parseInt(color.substr(0,2), 16);
		let pAux1 = parseInt(color.substr(2,2), 16);
		let pAux2 = parseInt(color.substr(4,2), 16);

        let aux = (pAux - (pAux * f)).toString();
        let aux1 = (pAux1 - (pAux1 * f)).toString();
        let aux2 = (pAux2 - (pAux2 * f)).toString();

        aux =  parseInt(aux, 10).toString(16);
        aux1 = parseInt(aux1, 10).toString(16);
        aux2 = parseInt(aux2, 10).toString(16);

        aux = aux.length == 1 ? '0' + aux : aux;
        aux1 = aux1.length == 1 ? '0' + aux1 : aux1;
        aux2 = aux2.length == 1 ? '0' + aux2 : aux2;

        return aux + aux1 + aux2;
    }

    async alterarConfigIcones(valor)
    {
        try {
            this.configuracao.Valor = valor;
            const resp = await this.popupConfigService.updateConfiguracaoGeral(this.configuracao.ConfiguracaoGeralID, this.configuracao);
            console.log(resp);
        } catch (error) {
        console.log(error);
        }
    }
}
